import ExecuteSearchResponseMessage from 'owa-service/lib/contract/ExecuteSearchResponseMessage';

export const doesExecuteSearchResponseHasError = (searchResponse: ExecuteSearchResponseMessage) =>
    !searchResponse || searchResponse.ResponseClass !== 'Success';
